module.exports = __webpack_public_path__ + "img/1.21700850.png";